var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M9,12c3.309,0,6-2.691,6-6S12.309,0,9,0,3,2.691,3,6s2.691,6,6,6Zm0-9c1.654,0,3,1.346,3,3s-1.346,3-3,3-3-1.346-3-3,1.346-3,3-3Zm2,14.341c-.64-.226-1.313-.341-2-.341-3.16,0-5.796,2.459-6.003,5.599-.052,.793-.711,1.401-1.495,1.401-.033,0-.066,0-.1-.003-.827-.054-1.453-.769-1.398-1.595,.31-4.711,4.262-8.401,8.997-8.401,1.029,0,2.038,.172,3,.513,.781,.276,1.19,1.133,.914,1.914-.276,.781-1.132,1.19-1.914,.914Zm12.26-1.325l-6.715,6.715c-.813,.813-1.915,1.269-3.064,1.269h-.955c-.276,0-.5-.224-.5-.5v-.955c0-1.149,.457-2.252,1.269-3.064l6.808-6.808c.953-.953,2.534-.894,3.409,.176,.761,.93,.598,2.317-.252,3.167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPen);
export default __webpack_public_path__ + "static/media/user-pen.5caf1c7b8615bf3d14345864b88e973b.svg";
export { ForwardRef as ReactComponent };